export const FormWrapper = ({ children, header, footer }) => {
  return (
    <div className="h-dvh bg-background text-text-primary flex flex-col">
      {header && (
        <div className="flex-shrink-0 bg-background-surface border-b border-border">
          <div className="max-w-3xl mx-auto px-6 py-4">{header}</div>
        </div>
      )}

      <div className="flex-1 flex flex-col min-h-0">
        <div className="max-w-3xl w-full mx-auto px-6 py-6 flex flex-col min-h-0">
          <div className="bg-background-surface border-l-2 border-primary shadow-sm p-8 flex flex-col flex-auto min-h-0 overflow-hidden">
            {children}
          </div>

          {footer && (
            <div className="mt-auto bg-background-surface border-l-2 border-primary px-8 py-4 text-sm text-text-secondary flex justify-end">
              {footer}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
